export const pathToTitleMapper: Record<string, string> = {
  "/insights/descriptive-statistics":
    "Descriptive Statistics",
  "/insights/survival-analysis": "Survival Analysis",
  "/insights/treatment-patterns": "Treatment Patterns",
  "/admin-dashboard/data-handler": "Data Handler",
  "/assistant": "AI Assistant",
};
